"use strict";
exports.__esModule = true;
exports.SmallText = exports.BodyText = exports.LargeText = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.DisplayText = exports.Typography = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
function Typography(props) {
    return react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, props));
}
exports.Typography = Typography;
function DisplayText(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h6" }), children));
}
exports.DisplayText = DisplayText;
function H1(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h1" }), children));
}
exports.H1 = H1;
function H2(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h2" }), children));
}
exports.H2 = H2;
function H3(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h3" }), children));
}
exports.H3 = H3;
function H4(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h4" }), children));
}
exports.H4 = H4;
function H5(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h5" }), children));
}
exports.H5 = H5;
function H6(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "h6" }), children));
}
exports.H6 = H6;
function LargeText(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "body1" }), children));
}
exports.LargeText = LargeText;
function BodyText(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "body2" }), children));
}
exports.BodyText = BodyText;
function SmallText(props) {
    var children = props.children, customColor = props.customColor, rest = tslib_1.__rest(props, ["children", "customColor"]);
    return (react_1["default"].createElement(core_1.Typography, tslib_1.__assign({}, rest, { style: { color: customColor }, variant: "caption" }), children));
}
exports.SmallText = SmallText;
//# sourceMappingURL=Typography.js.map